/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="76.12"
        height="108.39"
        viewBox="0 0 76.12 108.39"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M74.86 0a1.25 1.25 0 0 1 1.24 1.12v73.73a1.25 1.25 0 0 1-1.09 1.24H11.18a8.54 8.54 0 0 0-8.67 8.26v.31a8.69 8.69 0 0 0 8.41 8.41h13.7a1.24 1.24 0 0 1 1.31 1.18 1.25 1.25 0 0 1-1.18 1.32H11.18A11.17 11.17 0 0 1 .01 85v-1.23a.24.24 0 0 1 0-.12V12.07A12.08 12.08 0 0 1 11.78 0Zm-1.25 2.5H12.08a9.57 9.57 0 0 0-9.57 9.3v65.84l.12-.15a11.21 11.21 0 0 1 8.26-3.89h62.72ZM74.86 93.08a1.25 1.25 0 0 1 .13 2.49H38.52a1.25 1.25 0 0 1-.12-2.49Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M70.68 83.34a1.24 1.24 0 0 1 1.21 1.28 1.26 1.26 0 0 1-1.09 1.21H38.52a1.25 1.25 0 0 1-.12-2.49ZM24.62 83.34a1.25 1.25 0 0 1 .13 2.49H10.01a1.25 1.25 0 0 1-.13-2.49ZM12.08 0a1.26 1.26 0 0 1 1.25 1.12v73.73a1.25 1.25 0 0 1-2.49.13V1.25A1.24 1.24 0 0 1 12.08 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M74.01 74a1.252 1.252 0 1 1 1.73 1.81 12.25 12.25 0 0 0-3.79 8.49v.47a12.5 12.5 0 0 0 3.55 8.49l.25.26a1.245 1.245 0 1 1-1.74 1.78 15 15 0 0 1-4.55-10.12v-1.29a14.78 14.78 0 0 1 4.27-9.59Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M38.39 80.64H24.74a1.25 1.25 0 0 0-1.25 1.25v25.36a1.24 1.24 0 0 0 1.33 1.14 1.29 1.29 0 0 0 .67-.26l6.09-4.5 6.08 4.5a1.26 1.26 0 0 0 1.75-.25 1.27 1.27 0 0 0 .25-.75V81.89a1.25 1.25 0 0 0-1.25-1.25Zm-1.25 2.5v21.51l-4.82-3.58-.11-.08a1.26 1.26 0 0 0-1.38.08l-4.81 3.58V83.14Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M60.32 14.11H26.59a1.25 1.25 0 0 0-1.25 1.25v17.56a1.25 1.25 0 0 0 1.25 1.25h33.73a1.25 1.25 0 0 0 1.25-1.25V15.36a1.25 1.25 0 0 0-1.25-1.25Zm-1.25 2.5v15.06H27.84V16.61Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'BookWithBookmarkIcon';

export default Icon;
